import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { AlbumFolderWithIdentityAccess } from '../../../graphql/queries/album-folder';
import { openModal, closeModal } from '../../../actions/modal-actions';
import AlbumFolderPurchaseSelectIdentities from '../../../components/purchase/album-folder-purchase/AlbumFolderPurchaseSelectIdentities';
import { MeWithIdentities } from '../../../graphql/queries/account';
import {
  identitiesFilteredOnAccess,
  sortByIdentityRelationship,
} from '../../../util/identity';
import { AlbumFolderTags } from '../../../graphql/queries/album-folder-tags';
import { getPurchasedIdentitiesOnFolder } from '../../../util/account';
import { resetTagSelection } from '../../../actions/identity-tag-selection';

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  selectedIdentities: discoverAlbumFolder.identities,
});

const withUserData = graphql(MeWithIdentities, {
  props: ({ data: { me, loading } = {}, ownProps }) => ({
    loading,
    accountId: me?.id,
    identities: sortByIdentityRelationship(
      identitiesFilteredOnAccess(
        me?.linked_identities?.records ?? [],
        ownProps?.albumFolder?.album_identity_access,
      ),
    ),
    purchasedIdentities: getPurchasedIdentitiesOnFolder(
      me,
      ownProps?.albumFolder?.root?.id,
    ),
  }),
});

const withAlbumFolder = graphql(AlbumFolderWithIdentityAccess, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
    },
    notifyOnNetworkStatusChange: true,
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loading,
  }),
});

const mapDispatchToProps = {
  closeModal,
  openModal,
  resetTagSelection,
};

const withAlbumFolderTags = graphql(AlbumFolderTags, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
    },
    notifyOnNetworkStatusChange: true,
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    loadingTags: loading,
    tags: albumFolder?.tags?.records,
  }),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withAlbumFolderTags,
  withAlbumFolder,
  withUserData,
)(AlbumFolderPurchaseSelectIdentities);
